import * as React from 'react';
import type { SelectableContainerInputComponentProps } from '../types';
import { dataHooks, labelPlaceholder } from '../constants';
import { useSelectableContainerContext } from '../../SelectableContainer/SelectableContainer.context';
import {
  formatClassNames,
  HAS_CUSTOM_FOCUS_CLASSNAME,
} from '@wix/editor-elements-common-utils';
import semanticClassNames from '../SelectableContainerInput.semanticClassNames';
import classNames from 'clsx';

export type ClassNames = Record<string, string>;

const SelectableContainerInputCommon: React.FC<
  SelectableContainerInputComponentProps & { classes: ClassNames }
> = props => {
  const {
    inputName,
    inputLabel,
    inputAriaLabel,
    inputRef,
    selected,
    inputType,
    onFocus,
    onBlur,
  } = useSelectableContainerContext();
  const { id, selectedPreview = false, classes, customClassNames = [] } = props;
  const inputId = `SelectableContainerInput-${id}`;
  const isSelected = selected || selectedPreview;

  return (
    <div
      id={id}
      className={classes.wrapper}
      data-hook={dataHooks.selectableContainerInputContainer}
    >
      <div
        className={classNames(
          classes.root,
          formatClassNames(semanticClassNames.root, ...customClassNames),
        )}
      >
        <input
          id={inputId}
          name={inputName}
          ref={inputRef}
          checked={isSelected}
          className={classNames(classes.input, HAS_CUSTOM_FOCUS_CLASSNAME)}
          readOnly
          data-hook={dataHooks.selectableContainerInput}
          type={inputType}
          aria-label={inputAriaLabel}
          onFocus={onFocus}
          onBlur={onBlur}
        />
        <div className={classes.inputWrapper}>
          <span
            className={classNames(
              classes.customInput,
              formatClassNames(semanticClassNames.input),
            )}
          />
          <label
            className={classNames(
              classes.label,
              formatClassNames(semanticClassNames.label),
            )}
            htmlFor={inputId}
          >
            {inputLabel || labelPlaceholder}
          </label>
        </div>
      </div>
    </div>
  );
};

export default SelectableContainerInputCommon;
